import React, { createContext, useContext, useState } from 'react';
import Modal from 'common/src/components/widget/Modal';

export const ModalContext = createContext({});
export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};

export const ModalProvider = ({ children }) => {
    const [modalCardBody, setModalCardBody] = useState(null);
    const [modalTitle, setModalTitle] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [backdropClickClose, setBackdropClickClose] = useState(true);

    const openModal = ({
                           body = null,
                           title = '',
                           backdropClose = true
                       }) => {
        setModalCardBody(body);
        setModalTitle(title);
        setBackdropClickClose(backdropClose);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setModalCardBody(null);
        setModalTitle('');
        setBackdropClickClose(true);
    };

    return (
        <ModalContext.Provider value={{ openModal, closeModal }}>
            {children}
            <Modal
                showPopup={isOpen}
                onClose={closeModal}
                modalCardBody={modalCardBody}
                title={modalTitle}
                backdropClickClose={backdropClickClose}
            />
        </ModalContext.Provider>
    );
};
